var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/\xEC\x95\x8C\xEB\xA6\xBC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/\xEC\x95\x8C\xEB\xA6\xBC_2",
    d: "M7.49966 11.75C7.67489 11.75 7.82188 11.6907 7.94063 11.5722C8.05938 11.4537 8.11875 11.3068 8.11875 11.1316C8.11875 10.9564 8.05949 10.8094 7.94096 10.6906C7.82243 10.5719 7.67555 10.5125 7.50034 10.5125C7.32511 10.5125 7.17813 10.5718 7.05938 10.6903C6.94063 10.8088 6.88125 10.9557 6.88125 11.1309C6.88125 11.3061 6.94051 11.4531 7.05904 11.5719C7.17758 11.6906 7.32445 11.75 7.49966 11.75ZM6.99375 8.88125H8.11875V4.1375H6.99375V8.88125ZM7.50499 15.5C6.47081 15.5 5.49894 15.3031 4.58936 14.9094C3.67979 14.5156 2.88438 13.9781 2.20312 13.2969C1.52188 12.6156 0.984375 11.8197 0.590625 10.9092C0.196875 9.99873 0 9.02586 0 7.99063C0 6.95539 0.196875 5.98252 0.590625 5.07202C0.984375 4.16151 1.52188 3.36875 2.20312 2.69375C2.88438 2.01875 3.68026 1.48438 4.59077 1.09063C5.50127 0.696875 6.47414 0.5 7.50937 0.5C8.54461 0.5 9.51748 0.696875 10.428 1.09063C11.3385 1.48438 12.1313 2.01875 12.8063 2.69375C13.4813 3.36875 14.0156 4.1625 14.4094 5.075C14.8031 5.9875 15 6.96084 15 7.99501C15 9.02919 14.8031 10.0011 14.4094 10.9106C14.0156 11.8202 13.4813 12.6145 12.8063 13.2934C12.1313 13.9724 11.3375 14.5099 10.425 14.9059C9.5125 15.302 8.53916 15.5 7.50499 15.5Z",
    fill: "#F05E5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.4243c50e72b0616b30215774147558f0.svg";
export { ForwardRef as ReactComponent };